var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"menu-button",on:{"click":_vm.toggle}},[_c('span',{staticClass:"menu-button__icon-bar"}),_c('span',{staticClass:"menu-button__icon-bar"}),_c('span',{staticClass:"menu-button__icon-bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }